import { useQuery } from "@tanstack/react-query";
import { useEnsureAuthenticated } from "@/contexts/ensureAuthenticated";
import { getCorbanById } from "@/services/corban.service";
import { getCreditPromoterById } from "@/services/creditPromoter.service";
import { Box, Spinner, Flex } from "@chakra-ui/react";
import UsersTable from "./UsersTable";

export default function UsersPage() {
  const { user } = useEnsureAuthenticated();
  const corbanId = user?.corbanId;
  const creditPromoterId = user?.creditPromoterId;

  const { data: corban, isLoading: isLoadingCorban } = useQuery({
    queryKey: ["corban", corbanId],
    queryFn: () => getCorbanById(corbanId?.toString()),
  });

  const { data: creditPromoter, isLoading: isLoadingCreditPromoter } = useQuery({
    queryKey: ["creditPromoter", creditPromoterId],
    queryFn: () => getCreditPromoterById(creditPromoterId?.toString()),
  });

  const isLoading = isLoadingCorban || isLoadingCreditPromoter;

  if (isLoading) {
    return (
      <Flex justify="center" align="center" height="200px" width="100%">
        <Spinner
          size="xl"
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
        />
      </Flex>
    );
  }

  return (
    <Box width="100%">
      <UsersTable 
        corban={corban || undefined} 
        creditPromoter={creditPromoter || undefined} 
        isRegistryPage={true}
      />
    </Box>
  );
}
